import React from 'react';

import DefaultCard from './DefaultCard';

const CardGrid = ({ entries, Component = DefaultCard }) => (
  <div className="-mx-6 flex flex-wrap">
    {entries.map((entry) => (
      <div className="flex mb-12 md:w-1/2 px-6 w-full" key={entry.id}>
        <Component {...entry} />
      </div>
    ))}
  </div>
);

export default CardGrid;
